import { trackEvent } from './pixel'

export const CHECKOUT_URL = 'https://stretching360.impultienda.ar/checkout'

export const PRICE_LABEL = '$19 USD'

export function goToCheckout() {
  trackEvent('InitiateCheckout', {
    content_name: 'Megapack STRETCHING 360',
    value: 19,
    currency: 'USD',
  })
  window.location.href = CHECKOUT_URL
}
